import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import PracticeDetailForumComment from './PracticeDetailForumComment';
import paths from '../../../paths';

export default class PracticeDetailForumBlock extends Component {
  static propTypes = {
    practice: PropTypes.object.isRequired,
  };

  render() {
    const { practice } = this.props;
    return practice.comments && practice.comments.length ? (
      <div className="section -list-themes">
        <div className="section-title">Обсуждение случая</div>

        <div className="list-themes">
          {practice.comments.map(comment => (
            <PracticeDetailForumComment key={comment.id} comment={comment} />
          ))}

          <div className="list-themes-item">
            <div className="list-themes-author" />
            <div className="list-themes-desc">
              <div className="btn-group">
                <Link to={`${paths.advocates.forumTopic}/${practice.forumTopicAlias}`} className="btn -secondary">
                  Читать все сообщения
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    ) : (
      ''
    );
  }
}
